"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "civezzano": {
    "eeafe7da": [{
      "hkey": "100c2069",
      "slug": "civezzano",
      "name": "Civezzano",
      "primary": true,
      "skipSearch": false
    }],
    "castel-telvana": [{
      "hkey": "100c2069",
      "slug": "civezzano",
      "name": "Civezzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "260db644": [{
      "hkey": "100c2069",
      "slug": "civezzano",
      "name": "Civezzano",
      "primary": true,
      "skipSearch": false
    }],
    "santa-colomba": [{
      "hkey": "100c2069",
      "slug": "civezzano",
      "name": "Civezzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;